export default "__VITE_ASSET__0f57c8f3__"